import React, { useState } from "react";
import { Constantes, GaUtils, Utils } from "@common/utils";
import { useUnifiedMenu } from "../../store/unified-menu-context";
import { Application } from "./application";
import { MenuItemLink } from "./menu-item-link";
import { SubMenu } from "./submenu";

export const SubMenuItem = ({ item }) => {
    const { activeItemPath } = useUnifiedMenu();
    const domain = Utils.getMonorepoDomain();

    // El pulse se reinicia en cada carga de página y solo se apaga al hacer
    // clic en la opción durante la sesión actual (no se persiste).
    const [showPulse, setShowPulse] = useState(() => !!item.pulse);

    const dismissPulse = () => {
        if (!showPulse) return;
        setShowPulse(false);
    };

    const onClick = (e) => {
        e.stopPropagation();
        dismissPulse();

        const option = item.application ?? item.optionEvent;

        GaUtils.trackGAEvent(
            Constantes.GA_CATEGORY_EVENTS.CATEGORY_EVENT_NEW_UNIFIED_MENU,
            Constantes.GA_ACTION_EVENTS.EVENT_OPTION_MENU_CLICKED(option),
            Constantes.GA_LABELS_EVENTS.MENU_BAR_LEFT
        );

        if (item.path) {
            if (/^https?:\/\//.test(item.path)) {
                window.open(item.path, "_self");
            } else if (item.application !== Application.SCALIBUR) {
                window.open(`${domain}${item.path}`, "_self");
            }
        }
    };

    return (
        <li data-testid="submenu-item">
            <MenuItemLink
                {...item}
                isChild
                pulse={showPulse}
                onClick={onClick}
                active={!!activeItemPath && activeItemPath === item.path}
            />

            {item.children?.length && <SubMenu items={item.children} />}
        </li>
    );
};
